import React from 'react';
import { ShieldCheck } from 'lucide-react';
interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
}
export function AuthLayout({
  children,
  title,
  subtitle
}: AuthLayoutProps) {
  return <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4" data-id="element-62">
      <div className="w-full max-w-md space-y-8" data-id="element-63">
        <div className="flex flex-col items-center text-center" data-id="element-64">
          <div className="rounded-full bg-primary/10 p-4 mb-4" data-id="element-65">
            <ShieldCheck className="h-10 w-10 text-primary" data-id="element-66" />
          </div>
          <h1 className="text-3xl font-bold tracking-tight text-gray-900" data-id="element-67">
            {title}
          </h1>
          {subtitle && <p className="mt-2 text-sm text-gray-600" data-id="element-68">{subtitle}</p>}
        </div>

        <div className="bg-white p-8 shadow-lg rounded-xl border border-gray-100" data-id="element-69">
          {children}
        </div>

        <div className="text-center text-xs text-gray-500" data-id="element-70">
          &copy; {new Date().getFullYear()} سامانه جامع بیمه. تمامی حقوق محفوظ
          است.
        </div>
      </div>
    </div>;
}